import { all } from 'redux-saga/effects';
import authenSaga from './authen/saga';
import authSaga from './line/saga';

export default function* rootSaga() {
  yield all([authenSaga(), authSaga()]);
}
